import React, { useState } from 'react';
import {
  Grid,
  IconButton,
  Container,
  Button,
  Divider,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core';
import LogoName from './LogoName';
import Telophone from '../../assets/png/Telephone.png';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'none',
    maxWidth: '100%',
    margin: '0 auto',
    padding: '0.8rem 0',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      maxWidth: '90%'
    }
  },
  fitContentDiv: {
    width: 'fit-content'
  },
  navBtn: {
    letterSpacing: '0.095em',
    color: theme.palette.primary.secondary
  },
  menuItems: {
    marginLeft: '25px',
    paddingLeft: '25px',
    borderLeft: '2px solid rgba(196, 196, 196, 0.7)',
    borderRadius: 0,
    width: 'fit-content'
  }
}));

export default function Navbar() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const classes = useStyles();
  const menuItems = [];
  const [showDrawer, setShowDrawer] = useState(false);

  const TELEPHONE_NUMBER = '+44(0) 7771038880';

  return (
    <>
      <Grid
        container
        alignItems="center"
        direction="row"
        justify="space-between"
        className={classes.root}
        component={Container}>
        <Grid item className={classes.fitContentDiv}>
          <LogoName />
        </Grid>
        {md && (
          <Grid
            container
            item
            justify="flex-end"
            className={classes.fitContentDiv}>
            {menuItems.map((item, index) => (
              <Link
                key={`home-navbar-menu-item-${index}`}
                to={index === 0 ? '/home' : '#'}>
                <Button
                  color="secondary"
                  variant="text"
                  className={classes.navBtn}>
                  {item}
                </Button>
              </Link>
            ))}

            <Grid
              container
              item
              direction="row"
              justify="flex-end"
              className={classes.menuItems}>
              <a href={`tel:${TELEPHONE_NUMBER}`}>
                <IconButton style={{ padding: 0, margin: '0 0.1rem' }}>
                  <img src={Telophone} alt="Telophone" />
                </IconButton>
              </a>
              <Grid
                container
                item
                direction="column"
                justify="center"
                alignItems="flex-end"
                style={{ width: 'fit-content' }}>
                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    fontSize: '12px',
                    letterSpacing: '0.1rem',
                    fontWeight: 900
                  }}>
                  {TELEPHONE_NUMBER}
                </Typography>
                <Typography variant="body2" color="secondary">
                  Call For Booking Support
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
        {/* <Grid item>
          <IconButton color="primary" onClick={() => setShowDrawer(true)}>
            <MenuOpenIcon />
          </IconButton>
        </Grid> */}
      </Grid>

      <Drawer
        anchor="right"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}>
        <div
          style={{ width: '80vw' }}
          role="presentation"
          onClick={() => setShowDrawer(false)}
          onKeyDown={() => setShowDrawer(false)}>
          <Grid
            container
            direction="column"
            style={{ paddingLeft: '0.5rem', paddingTop: '1rem' }}>
            <Grid container item justify="space-between">
              <Grid item xs={6}>
                <LogoName />
              </Grid>
              <IconButton color="primary" onClick={() => setShowDrawer(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <List style={{ margin: '3rem 0' }}>
              <Divider />
              {menuItems.map((text, index) => (
                <React.Fragment key={`home-navbar-menu-items-drawer-${index}`}>
                  <ListItem button>
                    <ListItemText primary={text} />
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))}
            </List>

            <Grid item container style={{ paddingLeft: '0.5rem' }}>
              <Typography>
                <strong>Connect</strong>
                <br />
                000 000 0000
                <br />
                abc@gmail.com
              </Typography>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    </>
  );
}
